import { useEffectOnce } from 'react-use';

import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';

const useGettingCalendars = () => {
  const { response: calendars, onFetch } = useFetch('calendars', Api.CALENDARS);

  useEffectOnce(() => {
    onFetch();
  });

  return {
    calendars,
    onFetchCalendars: onFetch,
  };
};

export default useGettingCalendars;
